import AppConfigReducerInitialState from '../reducers/AppConfigReducer/AppConfigReducerInitialState';
import { isEmpty } from './utilities';
import { type IAppContextValue } from '../types/appConfigTypes';

/** Get the app config. */
export const getAppConfig = (): IAppContextValue => {
  // Get the site config from one of the expected locations.
  // For Drupal websites, this will be the Drupal settings.
  let appConfig = AppConfigReducerInitialState;

  if (
    typeof window !== 'undefined' &&
    typeof window.drupalSettings !== 'undefined' &&
    !isEmpty(window.drupalSettings.search_results_app)
  ) {
    appConfig = window.drupalSettings.search_results_app;
  }

  return appConfig;
};

/** Get the product search API Base Url from the the app config. */
export const getProductSearchApiBaseUrl = (): string => {
  let productSearchApiBaseUrl = '';
  const appConfig = getAppConfig();
  if (
    typeof appConfig !== 'undefined' &&
    typeof appConfig.product_search_api_base_url !== 'undefined'
  ) {
    productSearchApiBaseUrl = appConfig.product_search_api_base_url;
  }

  return productSearchApiBaseUrl;
};

/** Create drupal url. */
export const createUrl = (path: string): string => {
  let url = path;
  if (
    typeof window !== 'undefined' &&
    typeof window.Drupal !== 'undefined' &&
    typeof window.Drupal.url !== 'undefined'
  ) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    url = window.Drupal.url(path) as string;
  }

  return url;
};
